<template>
    <div class="about-index">
        <!--banner-->
        <div class="about">
            <banHead :bannerHead="banHead"></banHead>
        </div>
        <!--content-->
        <section>
            <!--content1-->
            <div class="story-cont">
                <div class="about-story center">
                    <h2 class="common-font">{{storyTitle}}</h2>
                    <p v-for="mes in story">{{mes}}</p>
                </div>
            </div>
            <!--content-award-->
            <div class="award-cont">
                <h2 class="common-font">Awards</h2>
                <div class="award-icon center">
                    <ul>
                        <li v-for="(icon,key) in aboutmsg">
                            <i :style="{'background-image':'url('+ icon.iconUrl +')'}" :_src="icon.iconUrl1" ></i>
                        </li>
                    </ul>
                </div>
            </div>
            <!--content-mes-->
            <div class="news-cont">
                <div class="news-mes center">
                    <div class="news-pro">
                        <img src="/static/image/about/6@1x.jpg" _src="/static/image/about/6@2x.jpg" alt="">
                        <message :detailMsg="aboutMsg"></message>
                    </div>
                    <div class='news-pro'>
                        <message :detailMsg="missionMsg"></message>
                        <img src="/static/image/about/Bitmap@1x.jpg" _src="/static/image/about/Bitmap@2x.jpg" alt="">
                    </div>
                </div>
            </div>
            <!--content-corporate-->
            <div class="corporate-cont">
                <div class="corporate-head center">
                    <div class="corporate-pro">
                        <h2 class="common-font">Corporate Social Responsibility</h2>
                        <p>At SENSORO, we see corporate social responsibility as a key to the success of our business
                            activities in the long run. Integrity and ethics play an important role in the
                            decision-making at our company, and making a positive impact on our environment, our
                            communities and employees is at the heart of our corporate culture. </p>
                    </div>
                    <img src="/static/image/about/architectural@1x.jpg" _src="/static/image/about/architectural@2x.jpg" alt="">
                    <div class="corporate-news">
                        <message :detailMsg="environment"></message>
                        <message :detailMsg="community"></message>
                    </div>
                </div>
            </div>
            <!--partner-->
            <div class="award-cont ">
                <h2 class="common-font">Partners</h2>
                <div class="award-icon partner-icon center">
                    <ul>
                        <li v-for="(icon,key) in partnermsg" :key="key">
                            <i :style="{'background':'url('+icon.iconUrl+')'}" :_src="icon.iconUrl1"></i>

                            <div class="icon-detail">
                                <p>{{partnermsg[key].msg}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import banHead from '../common/banHead';
    import aboutmsg from '../assets/js/case';
    import message from '../common/message';

    export default {
        name: "about",
        data() {
            return {
                banHead: {
                    title: 'About us',
                    msg: 'SENSORO was founded in July 2013 as part of the Microsoft Accelerator Program',
                    _src:'/static/image/about/Aboutus-banner@2x.jpg'
                },
                aboutmsg: aboutmsg.aboutmsg.aboutIcons,
                partnermsg: aboutmsg.aboutmsg.partnermsg,
                storyTitle: 'Our Story',
                story: ['Our company has an end-to-end IoT product line consisting of chips, sensors, communication modules, communication base stations and cloud to provide ultra-low cost solutions for customers around the world. SENSORO IoT solutions help create smart cities and connect the physical and digital worlds.', 'Our team has a total of more than 100 people with an average age of 28 years, 70% of employees work in our R&D department. Some of our core members come from companies such as Microsoft, Ericsson or Huawei, including senior experts in 5G and the communication field.'],
                aboutMsg: {
                    title: 'Our Approach',
                    msg: 'SENSORO was one of the first technology companies in the world to develop Bluetooth low-energy smart sensors and transmission technology. Our company has also independently developed the world\'s smallest dual-channel LPWAN chip and is building an ultra-low-cost, long-distance, globally-ready solution that includes front-end sensors, alpha-based IoT base stations, and big data analytics and marketing. '
                },
                missionMsg: {
                    title: 'Mission',
                    msg: 'Our mission at SENSORO is to leverage technology to create a safer and smarter way of life. We are building technologies that will play a critical role in the IoT ecosystem and that will facilitate widespread implementation of intelligent resource management and life safety solutions.'
                },
                environment: {
                    title: 'Our Environment',
                    msg: 'SENSORO is committed to taking care of our planet and fighting climate change. Our products help customers and their businesses to reduce their carbon footprints and make a more efficient use of our planet\'s natural resources. Customers can use SENSORO\'s IoT solutions to access information remotely which means less energy consumed, and through the deployment of our sensing technology we make smart resource management possible.'
                },
                community: {
                    title: 'Our Community and Employees',
                    msg: 'We are committed to empowering our communities and safeguarding people\'s life, helping to build smart cities and creating life safety solutions.We understand that our employees are the company\'s most valuable asset. We have created an inclusive and safe workplace where respect is key in each of our interactions. Only by creating an inspiring working environment can we deliver technologies and services that work best for all. '
                }
            }
        },
        created() {
        },
        mounted(){
            this.utils.getImg()
        },
        methods: {

        },
        components: {
            banHead,
            message
        }
    }
</script>

<style scoped lang="less">
    .about-index {
        @baseWidth: 1640px;
        width: 100%;
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        .center{
            width: @baseWidth;
            margin: 0 auto;
        }
        h2 {
            font-size: 28px;
            color: #252525;
            line-height: 36px;
        }
        p {
            font-size: 18px;
            line-height: 26px;
            color: #5d5d5d;
        }
        /*banner*/
        .about {
            width: 100%;
            .com-banner {
                background: url("/static/image/about/Aboutus-banner@1x.jpg") no-repeat center;
            }
        }
        /*content*/
        section {
            .story-cont {
                width: 100%;
                background: #FAFAFA;
                padding: 96px 0 110px;
                .about-story {

                    h2 {
                        text-align: center;
                        margin-bottom: 24px;
                    }
                    p {
                        width: 980px;
                        margin: 0 auto;
                        font-size: 14px;
                        text-align: center;
                        line-height: 22px;
                    }
                }
            }
            /*partner*/
            .award-cont {
                margin: 96px auto 112px;
                h2 {
                    text-align: center;
                    margin-bottom: 40px;
                }
                .partner-icon{
                    li{
                        cursor: pointer;
                    }

                }
                .award-icon {
                    /*padding: 0 140px;*/

                    ul {
                        display: flex;
                        /*flex: 1;*/
                        flex-wrap: wrap;
                        justify-content: space-between;
                        li {
                            width: 240px;
                            height: 120px;
                            /*margin-bottom: 146px;*/
                            text-align: center;
                            i {
                                display: block;
                                width: 240px;
                                /*height: 100%;*/
                                height: 120px;
                                background-size: cover;
                                background-position: center;
                                background-repeat: no-repeat;
                            }
                        }
                    }
                }
            }
            /*news-cont*/
            .news-cont {
                width: 100%;
                .news-mes {
                    img {
                        display: block;
                        width: 800px;
                    }
                    h2 {
                        margin-bottom: 24px;
                        color: #252525;
                    }
                    p {
                        color: #5D5D5D;

                    }
                    .news-pro {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        justify-items: center;
                        margin-bottom: 64px;
                        .news-detail {
                            width: 520px;
                        }
                    }
                }
            }
            /*corporate-cont*/
            .corporate-cont {
                width: 100%;
                margin: 120px 0;
                .corporate-head {
                    img{
                        display: block;
                        width: 100%;
                    }
                    .corporate-pro {
                        h2 {
                            text-align: center;
                        }
                        p {
                            width: 990px;
                            margin: 24px auto 64px;
                            font-size: 14px;
                            color: #5D5D5D;
                            text-align: center;
                            line-height: 22px;
                        }
                    }
                    .corporate-news {
                        display: flex;
                        justify-content: space-between;
                        margin-top: 64px;
                        padding: 0 100px;
                        .news-detail {
                            width: 42%;
                        }
                    }
                }
            }
            /*partner*/
            .award-icon {
                li {
                    /*cursor: pointer;*/
                    position: relative;
                }
                li:hover .icon-detail {
                    display: block;
                }
                .icon-detail {
                    position: absolute;
                    display: none;
                    width: 458px;
                    background: #FAFAFA;
                    text-align: left;
                    padding: 24px;
                    margin-left: 24px;
                    z-index: 200;
                    p {
                        color: #5D5D5D;
                        font-size: 16px;
                        line-height: 24px;
                    }

                }
                li:last-child .icon-detail {
                    margin-left: -218px;

                }

            }
        }
    }

    @media screen and (max-width: 1680px){
        @baseWidth: 1216px;
        @autoWidth:1256px;
        .about-index {
            width: 100%;
            min-width: @autoWidth;
            .center{
                width: @baseWidth;
                margin: 0 auto;
            }
            .about {
                width: 100%;
            }
            section {
                .award-cont {
                    .award-icon {
                        padding: 0;
                    }
                }
                .news-cont {
                    .news-mes {
                        img {
                            width: 592px;
                        }
                    }
                }
                .corporate-cont {
                    width: 100%;
                    .corporate-head {
                        img {
                            width: 100%;
                        }
                        .corporate-news {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 64px;
                            padding: 0;

                        }
                    }
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/about.vue